// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusBadge_root__xkshE","approved":"StatusBadge_approved__2F2Qm","published":"StatusBadge_published__1ao4o","blocked":"StatusBadge_blocked__2yXq7"};